import { useState } from 'react';
import { Link } from 'react-router';
import { authApi } from '@/api/auth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    await authApi.forgotPassword(email);
    setSent(true);
    setLoading(false);
  }

  if (sent) {
    return (
      <>
        <h2 className="text-xl font-semibold mb-4">Verifique seu e-mail</h2>
        <p className="text-gray-600 mb-4">Se existe uma conta com esse e-mail, enviamos um link para redefinir a senha.</p>
        <Link to="/login" className="text-primary hover:underline text-sm">Voltar para login</Link>
      </>
    );
  }

  return (
    <>
      <h2 className="text-xl font-semibold mb-6">Redefinir senha</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
          <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary" />
        </div>
        <button type="submit" disabled={loading}
          className="w-full py-2 px-4 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors disabled:opacity-50">
          {loading ? 'Enviando...' : 'Enviar link de redefinicao'}
        </button>
      </form>
      <p className="mt-4 text-sm text-gray-500">
        <Link to="/login" className="text-primary hover:underline">Voltar para login</Link>
      </p>
    </>
  );
}
